// extracted by mini-css-extract-plugin
module.exports = {"headSection":"styles_headSection__hrcYi","headBody":"styles_headBody__92_Wb","headImage":"styles_headImage__ABxCI","feedback":"styles_feedback__AOJjT"};